import { api } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useResourceSnapshot(time) {
  const queryKey = ['resourceSnapshot', time];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      return api
        .get(`resourcesSnapshot/${time.toISOString()}`, { signal })
        .json();
    },
    placeholderData: (previousData) =>
      previousData ?? {
        vehicles: {
          type: 'FeatureCollection',
          features: [],
        },
        people: {
          type: 'FeatureCollection',
          features: [],
        },
        incidents: {
          type: 'FeatureCollection',
          features: [],
        },
        events: {
          type: 'FeatureCollection',
          features: [],
        },
        callSigns: {
          type: 'FeatureCollection',
          features: [],
        },
        tags: {
          type: 'FeatureCollection',
          features: [],
        },
      },
    staleTime: 1000 * 60 * 60,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
